export const CyLivePosition = {
  LivePositionSidebarBody: "LivePositionSidebarBody",
  OtherDevices: "OtherDevices",
  ChangeDeviceName: "ChangeDeviceName",
  ChangeDeviceColor: "ChangeDeviceColor",
} as const;
